import { OrganizationRelocationStatus } from '../enums/organization-relocation-status-enum';

const pendingTransferConfirmationText = 'Pending Transfer Confirmation';
const rejectedTransferText = 'Rejected Transfer';
const queuedText = 'Queued';
const pendingText = 'Pending';
const movingText = 'Moving';
const invalidText = 'Invalid';

const relocationConfirmationMessage: ReadonlyMap<OrganizationRelocationStatus, string> = new Map([
    [ OrganizationRelocationStatus.PENDING_SOURCE_ACCEPTANCE, pendingTransferConfirmationText ],
    [ OrganizationRelocationStatus.PENDING_TARGET_ACCEPTANCE, pendingTransferConfirmationText ],
    [ OrganizationRelocationStatus.REJECTED, rejectedTransferText ]
]);

const relocationStatusToMessage: ReadonlyMap<OrganizationRelocationStatus, string> = new Map([
    [ OrganizationRelocationStatus.QUEUED, queuedText ],
    [ OrganizationRelocationStatus.ACCEPTED, queuedText ],
    [ OrganizationRelocationStatus.PENDING_SOURCE_ACCEPTANCE, pendingText ],
    [ OrganizationRelocationStatus.PENDING_TARGET_ACCEPTANCE, pendingText ],
    [ OrganizationRelocationStatus.RELOCATING, movingText ]
]);

export const relocationPendingConfirmationStatuses: ReadonlySet<OrganizationRelocationStatus> =
    new Set(relocationConfirmationMessage.keys());

export function getRelocationConfirmationMessageFor(status?: OrganizationRelocationStatus): string {
    return status ? (relocationConfirmationMessage.get(status) ?? '') : '';
}

export function getRelocationStatusMessageFor(status?: OrganizationRelocationStatus): string {
    return status ? (relocationStatusToMessage.get(status) ?? invalidText) : invalidText;
}
